module.exports = __webpack_public_path__ + "static/JuanHerrera-PortfolioAppendix-65c93ebcc10a21191f61520066707a09.pdf";